import { ReactComponent as PennyIcon } from "@assets/icons/penny_icon.svg";
import { ReactComponent as ZurichVerticalIcon } from "@assets/icons/zurich_vertical.svg";
import BottomBar from "@components/BottomBars/BottomBar";
import { AspectRatio, Box } from "@mantine/core";
import React from "react";
import { Link } from "react-router-dom";

type ZurichProviderProps = {};

const ZurichProvider: React.FC<ZurichProviderProps> = () => {
  return (
    <section className="grow flex items-start md:items-center justify-center border-t-4 border-l-0 md:border-t-0 md:border-l-4 border-[#F4E34E] px-0 md:px-2 lg:px-0">
      <div className="max-w-full md:max-w-[416px] md:overflow-hidden md:my-4 w-full pb-4 mx-auto md:border md:border-pn_gray-200 bg-pn_paper-1 rounded-3xl">
        <Box className="w-full relative overflow-hidden">
          <div className="rounded-2xl relative">
            <div className="bg-pn_yellow-50 h-[286px] w-full"></div>
            <div className="absolute left-1/2 top-1/2 transform -translate-x-1/2 -translate-y-1/2 flex items-center justify-center">
              <div className="rounded-full bg-[#F4E34E] relative left-[7.5px] w-[80px] h-[80px] flex items-center justify-center">
                <PennyIcon />
              </div>
              <div className="border w-[80px] h-[80px] relative -left-[7.5px] border-pn_gray-200 bg-pn_white rounded-full flex items-center justify-center">
                <ZurichVerticalIcon className="w-[55px] h-[35px]" />
              </div>
            </div>
          </div>
          <div className="absolute top-[47%] left-0 right-0 w-full">
            <AspectRatio ratio={16 / 9}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="100%"
                height="42"
                viewBox="0 0 375 42"
                fill="none"
              >
                <path
                  d="M75.399 331.369C250.199 298.993 335.857 123.093 536.034 63.155L530.95 35.5147C323.374 75.8681 158.833 -32.7349 -6.24216 11.1731C-72.968 31.1529 -107.019 73.6584 -122.139 125.995C-146.564 210.537 -99.1907 302.739 -18.8191 325.958C9.31538 334.087 43.7863 335.321 75.399 331.369Z"
                  fill="#F8F7F3"
                />
              </svg>
            </AspectRatio>
          </div>
        </Box>

        <div className="flex flex-col gap-y-2 py-4 px-6">
          <h2 className="text-pn-large-title text-pn_gray-950">
            You will soon receive an email from Zurich about your pension
          </h2>
          <span className="text-pn-body-regular !font-normal text-pn_gray-600">
            Penny and Zurich work together to provide you with the best
            pensions. Please review Zurich's email.
          </span>
        </div>

        <div className="pb-6 px-6 flex items-center gap-x-4">
          <Link className="btn-tertiary-sm" to={"https://mail.google.com/"}>
            Open Email
          </Link>
        </div>

        <div className="px-6 py-4 flex flex-col gap-y-6">
          <div className="flex flex-col gap-y-2">
            <span className="text-pn-body-large-emphasis text-pn_gray-950">
              Need help?
            </span>
            <span className="text-pn-body-large-regular text-pn_gray-600">
              We are always here to help you, feel free to call us.
            </span>
          </div>

          <div className="hidden w-full md:block">
            <Link
              to="/pension-application"
              className="btn-primary-lg w-full block text-center"
            >
              Close
            </Link>
          </div>
        </div>

        <div className="flex md:hidden mt-8">
          <BottomBar
            layout="single"
            onNext={"/pension-application"}
            labelNext="Close"
          />
        </div>
      </div>

      {/* <div className="pt-[80px] px-[30px] flex flex-col gap-y-[29px] max-x-[308px]">
        <div className="flex items-center justify-center">
          <div className="rounded-full bg-[#F4E34E] w-[80px] h-[80px] flex items-center justify-center translate-x-[8px]">
            <PennyIcon />
          </div>
          <div className="bg-pn_white border border-pn_gray-200 rounded-full w-[80px] h-[80px] flex items-center justify-center -translate-x-[8px]">
            <ZurichVerticalIcon />
          </div>
        </div>

        <div className="flex flex-col gap-y-6">
          <div className="flex flex-col gap-y-2 text-center justify-center">
            <span className="text-pn-headline-emphasis">
              You will soon receive an email from Zurich about your pension
            </span>
            <span className="text-pn-body-regular">
              Penny and Zurich work together to provide you with the best
              pensions. Please review Zurich's email.
            </span>
          </div>

          <button onClick={handleOpenMail} className="btn-primary-lg">
            Open Email
          </button>
        </div>
      </div>

      <div className="px-[15.5px] mt-[28px]">
        <CardInformation
          variant="phone_receive"
          description={
            <div className="flex flex-col gap-y-1">
              <span className="text-pn-callout-emphasis text-pn_gray-950">
                Need help?
              </span>
              <span className="text-pn-callout-regular text-pn_gray-950">
                We are always here to help you, feel free to call us.
              </span>
            </div>
          }
        />
      </div> */}
    </section>
  );
};
export default ZurichProvider;
